import { useEffect, useState } from 'react'
import { Box, Button, Grid, IconButton, Paper, Typography } from '@mui/material'
import Page from '../layout/Page'
import { FeatureFlags } from '../config/config'
import { getSiteConfig } from '../community/siteProvider'
import { Stack } from '@mui/system'
import { useNavigate } from 'react-router-dom'
import { AllInclusive, FactCheck, HealthAndSafety } from '@mui/icons-material'
import HomePageCarousel from './HeroCarousel/HomePageCarousel'

export default function CommunityHubLanding(props={}) {
  const navigate = useNavigate()
  const [isLoading, setIsLoading] = useState(true)
  
  const startLoading = () => {
    setIsLoading(true)
  }

  const stopLoading = () => {
    setIsLoading(false)
  }

  const initializePage = async () => {
    startLoading()
    // 
    stopLoading()
  }

  useEffect(() => {
    initializePage()
  }, [])

  const navButtons = () => {
    return [
      {l: 'Quality Hub', t: '/quality-hub/news', i: <FactCheck />},
      {l: 'Safety Hub', t: '/safety-community-hub/news', i: <HealthAndSafety />},
      {l: 'Sustainability Hub', t: '/sustainability-hub/news', i: <AllInclusive />}
    ].map(b => 
      <Box key={b.l.split(' ')[0]} component="button" sx={
        { p: 1, flexGrow: '1', justifyItems: 'center', border: '1px solid #CCC', borderRadius: '8px' }
        } onClick={() => navigate(b.t)}>
        <Stack direction='row' columnGap={2}>{b.i}<Typography variant='body1'>{b.l}</Typography></Stack>
      </Box>
    )
  }

  return (
    <Page {...props} isLoading={isLoading}
    >

      <Paper
        component="form"
        sx={{ backgroundColor: 'transparent', padding: 'unset', border: 'none', boxShadow: 'none', display: 'flex', flexDirection: 'column', flexWrap: 'wrap', margin: 'unset' }}
      >
        <Grid container rowGap={1}>
          <Grid item xs={12} sx={{
            // minHeight: 'calc(55vh)',
            // maxHeight: 'calc(55vh)',
            height: 'calc(55vh)',
            textAlign: 'center',
            alignContent: 'center',
            border: '1px dashed #CCC'
          }}>
          <HomePageCarousel
            cycleDurationMs={8000}
          />
          </Grid>
          <Grid item xs={12} padding='2'>
            <Stack direction='row' columnGap={2} justifyContent='space-between'>
              {navButtons()}
            </Stack>
          </Grid>
          <Grid item xs={12} sx={{
            minHeight: 'calc(30vh)',
            textAlign: 'center',
            alignContent: 'center',
            border: '1px dashed #CCC'
          }}>
          [Quick Links Component Placeholder]
          </Grid>
        </Grid>

      </Paper>
    </Page>
  )
}